export default __webpack_public_path__ + "media/images/images_v2/btn-icon5-bc99a03471cec7ef72f92f7bf38c52c0.png";